module.exports = __webpack_public_path__ + "static/media/mulher-empretec.648a66ee.png";